import 'bootstrap/dist/css/bootstrap.min.css';
import * as React from "react";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { graphql } from "gatsby";
import { Trans } from 'gatsby-plugin-react-i18next';

import fidelDeckruede from "../images/deckrueden/fidel_deckruede_.jpg";
import janDeckruede from "../images/deckrueden/jan_deckruede_.jpg";
import schickoDeckruede from "../images/deckrueden/schicko_deckruede.jpg";
import albarDeckruede from "../images/deckrueden/albar_deckruede.jpg";
import larsDeckruede from "../images/deckrueden/lars_deckruede.jpg";
import riccardoDeckruede from "../images/deckrueden/riccardo_deckruede.jpg";


const deckruedenData = [
  {
    name: "Fidel",
    image: fidelDeckruede,
    description: (
      <>
        Isabella<br />
        aa dd bcbc NS kyky<br />
        KW 0 PL 0 HD 0 ED 0<br />
        DM frei
      </>
    ),
  },
  {
    name: "Ravi",
    image: janDeckruede,
    description: (
      <>
        New Shade Mokka tan<br />
        ata bcbc Nd cocoe cocoe ee Ii kyky NN Ll<br />
        7 Panel clean<br />
        DM NN frei<br />
        Cystinurie NN frei<br />
        CDDY NN frei<br />
        CDPA NN frei<br />
        CMP NN frei<br />
        CHG NN frei<br />
        HSF4 NN frei<br />
        KW 0 PL 0 HD 0 ED 0
      </>
    ),
  },
  {
    name: "Lars",
    image: larsDeckruede,
    description: (
      <>
        New Shade Isabella Cherry tan<br />
        6,5 Panel clean<br />
        DM frei<br />
        N/CDDY<br />
        KW 0<br />
        PL 0<br />
        HD 0<br />
        ED 0
      </>
    ),
  },
  {
    name: "Albar vom Haus Falke",
    image: albarDeckruede,
    description: (
      <>
        Blue Trindle<br /><br />
        <strong>ZTP bestanden:</strong><br />
        KW 0 PL 0 HD 0 ED 0 OCD 0
      </>
    ),
  },
  {
    name: "Schicko vom Haus Falke",
    image: schickoDeckruede,
    description: (
      <>
        KW 1 PL 0 HD 0 ED 0 OCD 0 N/CDDY<br />
        aa bcbc Nd Ncoecoe Ne Ii kyky NN LI<br /><br />
        Jugendklasse Champion<br />
        Deutschland Sommer Sieger 2024<br />
        Sommer Special Winner 2024<br />
        Beauty Sommer Winner 2024<br />
        Jugendklasse Best of Class Platz 3
      </>
    ),
  },
  {
    name: "Riccardo vom Haus Falke",
    image: riccardoDeckruede,
    description: (
      <>
        Inter.Puppy Klasse Champion 2024<br />
        Best of Class – 1. Platz<br />
        Deutschland Sommer Sieger 2024<br />
        Beauty Sommer Winner 2024<br />
        Sommer Special Winner 2024<br /><br />
        Inter.Junghund Champion 2025<br />
        Best of Class – 2. Platz<br />
        Mehrfacher Sieger
      </>
    ),
  },
  ];

const Deckrueden = () => {
  return (
    <Layout>
      <Seo title="Deckrüden" />
      <div className="container mt-5 mb-5 pb-15">
        <h3 className="text-center mb-4"><Trans>Unsere Deckrüden</Trans></h3>
        <div className="row row-cols-1 row-cols-md-2 row-cols-xl-3 g-4">
          {deckruedenData.map((dog, idx) => (
            <div className="col" key={idx}>
              <div className="card h-100 shadow-sm">
                <img src={dog.image} className="card-img-top" alt={dog.name} />
                <div className="card-body">
                  <h5 className="card-title">{dog.name}</h5>
                  <p className="card-text">{dog.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ marginBottom: "3rem" }}></div>

    </Layout>
  );
};

export default Deckrueden;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
